<template>
  <main-layout>
    <contenu-principal :video="cp.video" :exercices="cp.exercices"/>
    <a href="https://www.luqei.com/integral.php">
      <img src="@/assets/luqei_integral.jpg" alt="" class="w-100">
    </a>
    <div class="p-4 text-center bg-secondary">
      <exercice-band title="S'entrainer comme à l'examen" title-class="text-light mb-5" :list="list"/>
      <b-btn variant="warning" @click="$router.push('/exercices')">Voir plus</b-btn>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/components/Nav/MainLayout";
import ExerciceBand from "@/components/ExerciceBand";
import {Produit} from "@/js/caller";
import ContenuPrincipal from "@/components/ContenuPrincipal";
import {DataFormat} from "@/js/utils";

export default {
  name      : "Main",
  components: {ContenuPrincipal, ExerciceBand, MainLayout},
  data() {
    return {
      list: [],
      cp  : {video: "", exercices: []}
    }
  },
  created() {
    Produit.List({
      OrderBy: "random",
      Limit  : 9,
      Having : {
        Null: [{
          field: "exercices",
          isNot: true,
        }]
      }
    }).then(res => {
      this.list = DataFormat.Produits(res);
    });
    Produit.ContenuPrincipal().then(res => {
      this.cp.video = res.video;
      this.cp.exercices = res.exercices;
    })
  }
}
</script>

<style scoped>

</style>